var exports = {
  "Pc": "TagListField.module__tagsContainer___NlZZNV",
  "Pr": "TagListField.module__tagsHeader___NlZZNV",
  "cm": "TagListField.module__tagsLabel___NlZZNV",
  "jw": "TagListField.module__tagInputRow___NlZZNV",
  "Cs": "TagListField.module__tagsList___NlZZNV",
  "Tc": "TagListField.module__tag___NlZZNV",
  "xH": "TagListField.module__tagRemoveButton___NlZZNV",
};

module.exports = exports;
